import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const template = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.TEMPLATE_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.TEMPLATE_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.TEMPLATE_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response;
      return draft;
    case ACTIONS.TEMPLATE_ERROR:
      draft.loading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default template;
